"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputToggle = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var InputToggle = function (_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", __assign({ type: "checkbox", className: "br-sr-only peer" }, props, { onChange: onChange })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-h-6 br-w-10 br-rounded-full br-bg-blue-100 br-border br-border-blue-300 br-box-content'), onClick: function () { return onChange(); } },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('br-h-4 br-w-4 br-ml-1 br-mt-1 br-rounded-full br-transition', {
                    'br-bg-blue-300': !props.checked,
                    'br-bg-green-400': props.checked,
                    'br-translate-x-4': props.checked
                }) }))));
};
exports.InputToggle = InputToggle;
